import { apiUrl } from "../utils/api";

/** Strukturierte Anzeige-Angaben (Backend `notification-meta.ts`); Altbestand: null. */
export interface NotificationMeta {
  mail?: {
    mailbox?: string | null;
    messageId?: string | null;
    internetMessageId?: string | null;
    absender?: string | null;
    betreff?: string | null;
    mailLinkId?: number | null;
  };
  vorgang?: { id: number; titel?: string | null; inhaberKuerzel?: string | null };
  /** To-do, an dem die Mail hängt (beim Anlegen gespeichert; maßgeblich ist `todoTitel`). */
  todo?: { id: number; titel?: string | null };
  rolle?: "inhaber" | "hauptverantwortlich" | "bearbeiter" | "zu_informieren" | null;
  faelligAm?: string | null;
}

export interface NotificationDto {
  id: number;
  type: string;
  title: string;
  body?: string | null;
  refType?: string | null;
  refId?: number | null;
  link?: string | null;
  actorName?: string | null;
  /** Führender Kontakt bei Vorgangs-/To-do-Mitteilungen — nur mit Leserecht, sonst null. */
  kundeName?: string | null;
  /** Vorgangs-Mail: Titel des To-dos, an dem die Mail hängt — beim Lesen aufgelöst, sonst null. */
  todoTitel?: string | null;
  createdAt: string;
  readAt?: string | null;
  meta?: NotificationMeta | null;
}

async function req<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`API error ${res.status}: ${txt}`);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export const notificationService = {
  /** Eigene Benachrichtigungen, neueste zuerst. */
  async listMine(): Promise<NotificationDto[]> {
    return req<NotificationDto[]>(apiUrl("notifications"));
  },
  async markRead(id: number): Promise<void> {
    await req<void>(apiUrl(`notifications/${id}/read`), { method: "PATCH" });
  },
  async markAllRead(): Promise<void> {
    await req<void>(apiUrl("notifications/read-all"), { method: "POST" });
  },
};
